export class Template {
  templateId: number;
  name: string;
  description: string;
  isActive: boolean;
  dateCreated: Date;
  dateUpdated: Date;
  createdBy: any;
  tasks: TemplateTask[];
}

export class TemplateTask {
  templateTaskId: number;
  templateId: number;
  taskId: number;
  name: string;
  description: string;
  order: number;
  isCompleted: boolean;
}

